import { useSelector } from 'react-redux';
import { isAuthenticating } from '../helper';

const useIsAuthenticating = () => {
  const { state } = useSelector(({ auth }) => auth);
  return { authInProgress: isAuthenticating(state) };
};

const useApprovedAuthenticated = () => {
  const { currentUser, role: { approved, isLoading } } = useSelector(({ auth }) => auth);
  return { approved: !isLoading && approved && currentUser && !currentUser.isGuest };
};

const useApprovedIsGuest = () => {
  const { currentUser, role: { approved } } = useSelector(({ auth }) => auth);
  return { approved, isGuest: currentUser ? currentUser.isGuest : true };
};

export default {
  useApprovedAuthenticated,
  useApprovedIsGuest,
  useIsAuthenticating,
};
